import React from "react";
import { useProfile } from "../context/ProfileContext";
import { Flame, User } from "lucide-react";

export default function ProfilePill() {
  const { profile } = useProfile();
  if (!profile.onboarded) return null;
  return (
    <div className="hidden sm:flex items-center gap-2 bg-white border border-[#DCD7CE] rounded-full pl-1 pr-3 py-1" data-testid="profile-pill">
      <div className="w-7 h-7 rounded-full bg-[#FBE7DF] grid place-items-center text-[#E07A5F]">
        <User size={14} />
      </div>
      <span className="text-xs font-semibold text-[#1A1A1A] max-w-[100px] truncate" data-testid="profile-name">
        {profile.name}
      </span>
      <span className="inline-flex items-center gap-1 text-[#E07A5F] text-xs font-bold" data-testid="profile-streak">
        <Flame size={13} /> {profile.streak || 0}
      </span>
    </div>
  );
}
